// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"ccce66c6","631":"e68ad6d5"}[chunkId] + ".chunk.js";
};